<svg fill="currentColor" viewBox="0 0 16 16">
  <rect x="1" y="3" width="10" height="1.5" rx="1" />
  <rect x="3" y="7" width="10" height="1.5" rx="1" />
  <rect x="5" y="11" width="10" height="1.5" rx="1" />
</svg>
